import * as React from 'react';

import { FullMatchFragment } from '../../../generated/graphql';
import { TextLink } from '../../../components/ClickableText';
import { paths } from '../../../paths';
import { Card } from '../../../components/Card';
import { CardHeading } from '../../../components/CardHeading';

interface Props {
  match: FullMatchFragment;
}

const MATCH_REPORT_EXCERPT_LENGTH = 120;

export const MatchReportCard: React.FC<Props> = ({ match }) => {
  if (!match.matchReport) {
    return null;
  }

  const truncatedMatchReport = match.matchReport.slice(
    0,
    MATCH_REPORT_EXCERPT_LENGTH,
  );

  const isTruncated = truncatedMatchReport.length < match.matchReport.length;

  return (
    <Card className="bg-white">
      <CardHeading className="mb-6">Match Report</CardHeading>
      <article className="prose prose-sm">
        {isTruncated ? `${truncatedMatchReport}...` : truncatedMatchReport}
      </article>
      {isTruncated ? (
        <p className="mt-2 text-sm">
          <TextLink to={paths.match.matchReport(match.id)}>
            Read report
          </TextLink>
        </p>
      ) : null}

      {match.team.isCaptain ? (
        <p className="text-sm text-right">
          <TextLink to={paths.match.settings.matchReport(match.id)}>
            Edit
          </TextLink>
        </p>
      ) : null}
    </Card>
  );
};
